export default __webpack_public_path__ + "bbad1b8158caa3380268c1614c82677c.svg";